<template>
  <section v-if="!isClose" class="Modal">
    <Card class="Modal__card" :class="[`Modal__card--${size}`]">
      <header class="Modal__header">
        <Heading :heading="heading" type="tertiary" level="1" />
      </header>
      <!-- <button class="Modal__closeButton" aria-label="閉じる">
        <Icon class="Modal__icon" iconName="Close" @click="onClickModalClose" />
      </button> -->
      <slot />
    </Card>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Card from '@/components/atoms/Card.vue';
import Heading from '@/components/atoms/Heading.vue';
// Used by the commented-out close button in the template above.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icon from '@/components/atoms/IconBase.vue';

defineOptions({
  name: 'ModalBase',
});

interface Props {
  heading?: string;
  size?: string;
}

withDefaults(defineProps<Props>(), {
  heading: '',
  size: 'medium',
});

const emit = defineEmits<{
  (e: 'closeModal'): void;
}>();

const isClose = ref(false);

// Used by the commented-out close button in the template above.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function onClickModalClose(): void {
  emit('closeModal');
}
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_forward.scss' as *;

.Modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $service-z-index-ff;
  width: 100vw;
  height: 100vh;
  background-color: rgb(0 0 0 / 40%);

  & &__card {
    position: absolute;
    top: 50%;
    left: 50%;
    box-shadow: $service-shadow-mf;
    transform: translateY(-50%) translateX(-50%);

    &--extraSmall {
      width: $service-unit * 75;
      padding: $service-unit * 3;
    }

    &--small {
      width: $service-unit * 100;
      padding: $service-unit * 6;
    }

    &--medium {
      width: $service-unit * 150;
      padding: $service-unit * 4 $service-unit * 5 $service-unit * 6;
    }
  }

  &__header {
    position: relative;
    text-align: center;
  }

  &__closeButton {
    position: absolute;
    top: $service-unit * 4;
    right: $service-unit * 4;
    width: $service-unit * 6;
    height: $service-unit * 6;
    cursor: pointer;
    background-color: $color-white-100;
    border-radius: 50%;

    &:hover {
      background-color: $color-gray-20;
    }
  }

  & &__icon {
    width: $service-unit * 6;
    height: $service-unit * 6;
    color: $color-gray-80;
  }
}
</style>
